export default "__VITE_ASSET__CK_b23O___"